import { memo } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useToast } from 'hooks';
import { Button, Text } from 'components';

const Unsupported = (): JSX.Element => {
  const toast = useToast();

  const onCopiedToClipboard = () => {
    toast.info('Copied to clipboard!', { id: 'COPY_TO_CLIPBOARD' });
  };

  return (
    <Text className="bg-warning rounded color-black p-8" size="h4">
      For the best experience open the link on the latest version of Chrome or Safari.{' '}
      <CopyToClipboard text={window.location.toString()}>
        <Button size="xs" onClick={onCopiedToClipboard} variant="text" color="blue">
          copy link
        </Button>
      </CopyToClipboard>
    </Text>
  );
};

export const memoizedUnsupported = memo(Unsupported);

export default memoizedUnsupported;
